import { Locale } from '@synergy/models';
import countries from 'i18n-iso-countries';
import deCountries from 'i18n-iso-countries/langs/de.json';
import frCountries from 'i18n-iso-countries/langs/fr.json';
import itCountries from 'i18n-iso-countries/langs/it.json';

import { CountryAutocomplete } from '../components/country/country-autocomplete-list';

countries.registerLocale(deCountries);
countries.registerLocale(frCountries);
countries.registerLocale(itCountries);

export const getCountries = (locale: Locale): CountryAutocomplete[] =>
    Object.entries(countries.getNames(locale.split('_')[0])).map(([key, value], index) => {
        return {
            id: index,
            code: key,
            name: value,
        };
    });

export const getCountry = (locale: Locale, code: string): CountryAutocomplete => {
    return {
        id: 999,
        code,
        name: countries.getName(code, locale.split('_')[0]) ?? '',
    };
};
